import { Checkbox } from 'antd';
import React, { FC } from 'react';
import {
  ResourceManagementConfig,
  SoftAllocationConfig,
} from 'api/resource-management/types';
import { Loading } from 'components/atoms/loading';
import { MaskableContent } from 'components/atoms/maskable-content';
import { useTranslation } from 'hooks/use-translation';
import { FeatureControl, SettingToggleTitle } from './components';
import { SectionContent, SectionHeader } from './styles';

interface Props {
  isConfigLoading: boolean;
  initialConfig?: ResourceManagementConfig;
  handleConfigMutation: (softAllocationConfig: SoftAllocationConfig) => void;
}

export const SoftAllocationSettings: FC<Props> = ({
  isConfigLoading,
  initialConfig,
  handleConfigMutation,
}) => {
  const toggleAllocationMedium = (checked: boolean) => {
    if (initialConfig == null) {
      return;
    }

    handleConfigMutation({
      meta: initialConfig.softAllocations.meta,
      enabled: checked,
    });
  };

  const toggleAllocationSetting = (controlName: string, isEnabled: boolean) => {
    if (initialConfig == null) {
      return;
    }

    handleConfigMutation({
      ...initialConfig.softAllocations,
      meta: {
        ...initialConfig.softAllocations.meta,
        [controlName]: isEnabled,
      },
    });
  };

  return (
    <section>
      <SectionHeader>
        {isConfigLoading ? (
          <Loading />
        ) : (
          <Checkbox
            checked={initialConfig?.softAllocations.enabled ?? false}
            onChange={(e) => toggleAllocationMedium(e.target.checked)}
            data-cy="settings.resource-management.soft-allocations.switch"
          />
        )}

        <SettingToggleTitle
          primaryTitle={useTranslation(
            'settings.resource_management.soft_allocations.title',
          )}
          secondaryTitle={useTranslation(
            'settings.resource_management.soft_allocations.description',
          )}
        />
      </SectionHeader>
      <MaskableContent
        showMask={!(initialConfig?.softAllocations.enabled ?? false)}
        data-cy="settings.resource-management.soft-allocations.content"
      >
        <SectionContent>
          <FeatureControl
            controlName="templateDefault"
            isEnabled={
              initialConfig?.softAllocations.meta.templateDefault ?? false
            }
            description={useTranslation(
              'settings.resource_management.soft_allocations.controls.template_default',
            )}
            onChange={toggleAllocationSetting}
            isLoading={isConfigLoading}
          />
        </SectionContent>
      </MaskableContent>
    </section>
  );
};
